// extracted by mini-css-extract-plugin
export var noSpinners = "_sf-6";
export var percentageInput = "_sf-7";
export var variantColor1 = "_sf-0";
export var variantColor2 = "_sf-1";
export var variantColor3 = "_sf-2";
export var variantColor4 = "_sf-3";
export var variantColor5 = "_sf-4";
export var variantColor6 = "_sf-5";